import { QueryClient } from '@tanstack/react-query';

/**
 * Default React Query client tuned for an OTA — listings cache for 60s,
 * mutations don't retry, and stale data renders immediately while we refetch.
 */
export function createQueryClient(): QueryClient {
  return new QueryClient({
    defaultOptions: {
      queries: {
        staleTime: 60_000,
        gcTime: 5 * 60_000,
        refetchOnWindowFocus: false,
        retry: 1,
      },
      mutations: {
        retry: 0,
      },
    },
  });
}
